// extracted by mini-css-extract-plugin
export default {"wrapper":"organization_wrapper__vauv-","header":"organization_header__IwrZF","siteName":"organization_siteName__Mc75b","stub":"organization_stub__5FD8A"};